<template>
  <div class="dialog" v-show="dialogStatus">
    <div class="title">
      <span>下载管理</span> <i class="el-icon-close" @click="close"></i>
    </div>
    <div class="body">
      <div class="item" v-for="(item, idx) in downDate" :key="idx">
        <img src="../../assets/02.jpg" alt="" />
        <div>
          <div style="display: flex">
            {{ item.name }}
            <div style="display: inline-block; margin-left: auto"></div>
            {{ percentage(idx) }}
          </div>
          <el-progress style="width: 310px" :percentage="item.dlProgress" :color="downColors" :format="downFormat"
            stroke-linecap="square"></el-progress>
        </div>
      </div>
    </div>
    <div class="footer"></div>
  </div>
</template>

<script>
import Axios from "axios";
import { editDownloadRecord } from "../../api/index";
export default {
  name: "downloadProduct",
  data() {
    return {
      downDate: this.$store.state.data.downloadList,
      downColors: [
        { color: "#f56c6c", percentage: 20 },
        { color: "#e6a23c", percentage: 40 },
        { color: "#6f7ad3", percentage: 60 },
        { color: "#1989fa", percentage: 80 },
        { color: "#5cb87a", percentage: 100 },
      ],
    };
  },
  computed: {
    percentage() {
      return (idx) => {
        if (!this.downDate[idx].status) {
          if (!this.downDate[idx].past) {
            this.downDate[idx].past = true;
            editDownloadRecord(
              {
                id: this.downDate[idx].id,
                product_id: this.downDate[idx].product_id,
                status: 2,
              },
              (res) => {}
            );
          }
          return "错误";
        } else if (this.downDate[idx].dlProgress === 100) {
          if (!this.downDate[idx].past) {
            this.downDate[idx].past = true;
            editDownloadRecord(
              {
                id: this.downDate[idx].id,
                product_id: this.downDate[idx].product_id,
                status: 1,
              },
              (res) => {}
            );
          }
          return "完成";
        } else {
          return `${this.downDate[idx].dlProgress}%`;
        }
      };
    },
  },

  props: {
    // product_id: String,
    // name: String,
    dialogStatus: Boolean,
  },
  methods: {
    downFormat(percentage) {
      return "";
      // if (!this.downDate[0].status) return '错误'
      // return percentage === 100 ? '完成' : `${percentage}%`
    },
    close() {
      this.$emit("close");
    },
    download(product) {
      const _this = this;
      this.downDate.push({
        dlProgress: 0,
        flag: true,
        status: true,
        name: product.name,
        product_id: product.product_id,
        past: false,
        id: product.id,
      });
      const last = this.downDate.length - 1;
      Axios.post(
        "App/product/download",
        { product_id: _this.downDate[last].product_id },
        {
          timeout: 5000000000,
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          responseType: "blob",
          onDownloadProgress(progress) {
            if (progress.total === 0) return;
            if (progress.loaded === progress.total) {
              _this.$message.success("下载成功");
            }
            _this.downDate[last].dlProgress = Math.round(
              (progress.loaded / progress.total) * 100
            );
          },
        }
      )
        .then((res) => {
          if (res.headers["x-header-one"]) {
            let headerOne = JSON.parse(res.headers["x-header-one"]);
            if (headerOne.status === "fails") {
              _this.downDate[last].status = false;
              _this.downFormat(last);
              _this.$message.error(headerOne.message);
              return;
            }
            const a = document.createElement("a");
            a.href = URL.createObjectURL(res.data);
            const name = JSON.parse(
              res.headers["content-disposition"].split(";")[1].split("=")[1]
            );
            a.download = name;
            a.click();
            URL.revokeObjectURL(a.href);
            a.remove();
          }
        })
        .catch((err) => {
          console.log(err);
        });
      // )(last)
    },
  },
  mounted() {
    // this.download()
  },
};
</script>

<style lang="scss" scoped>
.dialog {
  -ms-overflow-style: none;
}
.dialog::-webkit-scrollbar {
  width: 0 !important;
}
.dialog {
  overflow: -moz-scrollbars-none;
}
.dialog {
  overflow: auto;
  z-index: 9999;
  background-color: #fff;
  width: 400px;
  height: 300px;
  border-radius: 5px;
  position: fixed;
  bottom: 20px;
  right: 20px;
  animation: enter 0.5s ease-in-out;
  box-shadow: 0 0 3px 0px rgba(0, 0, 0, 0.3);
  .title {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    i {
      color: #979aa0;
    }
  }
  .body {
    display: flex;
    flex-direction: column-reverse;
    .item {
      display: flex;
      padding: 5px 20px;
      justify-content: space-between;
      color: #979aa0;
      font-size: 15px;

      img {
        width: 40px;
        height: 40px;
        margin-right: 10px;
      }
      /deep/ .el-progress-bar {
        padding-right: 0;
      }
    }
  }
  .footer {
    color: #979aa0;
  }
}

@keyframes enter {
  from {
    opacity: 0;
    right: -500px;
  }
  to {
    right: 20px;
    opacity: 1;
  }
}
</style>
